import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ASYNC_GENERATE_BUTTON';

export const {
    action: generateAsyncLink,
    success: generateAsyncLinkSuccess,
    failed: generateAsyncLinkFailed,
} = createAction(
    `${domain}/GENERATE_ASYNC_LINK`,
    (identifier: string, generateUrl: (...args: any[]) => string, args: any) => ({identifier, generateUrl, args}),
    (identifier: string, url: string) => ({identifier, url}),
    (error: Error, identifier) => ({error, identifier}),
);

export const {action: generateAsyncLinkGQL} = createAction(
    `${domain}/GENERATE_ASYNC_LINK_GQL`,
    (identifier: string, args: any) => ({identifier, args}),
);

export const {action: generateAsyncLinkUpdate} = createAction(
    `${domain}/GENERATE_ASYNC_LINK_UPDATE`,
    (identifier, percentage) => ({identifier, percentage}),
);

export const {action: setAsyncLinkGenerationId} = createAction(
    `${domain}/SET_ASYNC_LINK_GENERATION_ID`,
    (identifier, generationId) => ({identifier, generationId}),
);
